module.exports = __webpack_public_path__ + "img/punto-6.58e8adaf.png";